import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

// The one place printed output is allowed to live.
//
// Print content used to sit where it was authored — inside a modal. That broke in
// two ways at once: the modal overlay is `position: fixed`, and browsers paint a
// fixed subtree on the FIRST sheet only; meanwhile the app behind it was hidden
// with `visibility: hidden`, which still occupies its full height, so the document
// paginated across the whole app. Between them, a print run came out as one good
// page followed by a blank page for every page of app behind it — on a label roll,
// one printed label and a fistful of blank ones.
//
// Rendering here instead puts the content in a plain, statically positioned child
// of <body>, where print CSS (`body > *:not(.print-root)`) drops everything else
// outright and the content paginates on its own — exactly as many pages as it needs.
// The host is hidden on screen, so a modal keeps rendering its own preview.
//
// `bare` removes the page padding, for label rolls that set their own @page size.
const PrintPortal = ({ children, bare }) => {
  const [host] = useState(() => document.createElement('div'));

  useEffect(() => {
    host.className = `print-root${bare ? ' bare' : ''}`;
    document.body.appendChild(host);
    return () => { document.body.removeChild(host); };
  }, [host, bare]);

  return createPortal(children, host);
};

export default PrintPortal;
